'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PresenceGroupItemProvider", {
    enumerable: true,
    get: function() {
        return PresenceGroupItemProvider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _PresenceGroupChildContext = require("../contexts/PresenceGroupChildContext");
const PresenceGroupItemProvider = (props)=>{
    const { appear, childKey, onExit, visible, unmountOnExit } = props;
    const contextValue = _react.useMemo(()=>({
            appear,
            visible,
            onExit: ()=>onExit(childKey),
            unmountOnExit
        }), [
        appear,
        childKey,
        onExit,
        visible,
        unmountOnExit
    ]);
    return /*#__PURE__*/ _react.createElement(_PresenceGroupChildContext.PresenceGroupChildContext.Provider, {
        value: contextValue
    }, props.children);
};
